
export default {
  props: {
    stats: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isLargeScreen() {
      return this.$matchesBreakpoint('m')
    },
    numberOfColumns() {
      return this.isLargeScreen ? 3 : 1
    },
  },

  methods: {
    parseSeries(data) {
      return data.map((serie, index) => {
        return {
          ...serie,
          name: this.$gettext(serie.name),
          yAxis: index ? 1 : 0,
        }
      })
    },

    getMonthName(timestamp) {
      const formatter = new Intl.DateTimeFormat(this.$i18n.locale, {
        month: 'long',
      })

      return formatter.format(new Date(timestamp))
    },
  },
}
